import React, { useState } from 'react';
import PropTypes from 'prop-types';

const SearchContext = React.createContext({
  search: '',
  filters: [],
});

const SearchProvider = ({ children }) => {
  const [search, setSearch] = useState('');
  const [filters, setFilters] = useState([]);

  const updateSearch = newSearch => setSearch(newSearch);
  const updateFilter = filter => setFilters(filter);

  return (
    <SearchContext.Provider
      value={{
        search,
        filters,
        updateSearch,
        updateFilter,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

SearchProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const SearchConsumer = SearchContext.Consumer;

export { SearchProvider, SearchConsumer };
